<template lang="html">
  <div class="clickup">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>
              Clickup CRM
              <small v-if="!activeIntegration">(Inativo)</small>
            </h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font title="Configurações" size="6" color="black" @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font title="Configurações" size="6" color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button tag="clickup" class="mb-1" :width="90" :height="30" :font-size="15"
              :value="activeIntegration" :sync="true" :labels="{ checked: 'Ativo', unchecked: 'Ativar' }"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="confirmDelete" ref="confirmDelete" data-keyboard="false"
      data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com o Clickup CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Não</button>
              <button type="button" class="btn btn-primary" @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="updateIntegration" ref="updateIntegration"
      data-keyboard="false" data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between align-items-center">
            <h4 class="modal-title">Configurar Clickup CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="errorAlert" />
            <p class="text-center">
              Para gerar/copiar seu Token de acesso pessoal
              <a class="link" href="https://app.clickup.com/settings/apps" target="_blank">
                clique aqui
              </a>
            </p>
            <div class="form-group row">
              <label for="token" class="col-sm-4 col-form-label">Token de acesso pessoal</label>
              <div class="col-sm-8">
                <input id="token" type="text" class="form-control" v-model="token">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Usuário Clickup</label>
              <div class="col-sm-8">
                <select class="form-control" id="userId" v-model="userId">
                  <option v-for="option in usersOptions" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <div class="buttons">
                <button type="button" class="btn btn-primary" :disabled="!configReady"
                  @click.prevent="saveIntegration">{{ labelSubmit }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="successIntegration" ref="successIntegration"
      data-keyboard="false" data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Clickup CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="uninstallIntegration" ref="uninstallIntegration"
      data-keyboard="false" data-backdrop="static" aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Clickup CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialClickup"
      title="Tutorial Clickup CRM"
      video-url="https://www.youtube.com/embed/RGBLExzYdWE?si=vxcqdtwrORUfzI2g" />
  </div>
</template>
<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationClickup',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      userId: null,
      usersOptions: [],
      token: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations?filter[where][gateway]=clickup`)
          .then(integrations => {
            this.integration = integrations.pop()
            if (this.integration && this.integration.metadata) {
              if (this.integration.metadata.userId) this.userId = this.integration.metadata.userId
              if (this.integration.metadata.token) this.token = this.integration.metadata.token
            }
            return resolve()
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    saveIntegration () {
      return new Promise((resolve, reject) => {
        this.error = null
        if (!this.configReady) {
          this.error = 'Houve um erro ao salvar a integração. Por favor, tente novamente.'
          return resolve()
        }
        if (this.token) {
          this.loadUsers().then(() => {
            const integrationParams = {
              gateway: 'clickup',
              webhook: true,
              webhookConstraint: {
                metadata: {
                  api4comGateway: 'clickup'
                }
              },
              metadata: {
                token: this.token,
                userId: this.userId,
                webhookUrl: process.env.API4COM_WEBHOOK_RECEIVER_URL,
                webhookVersion: 'v1.4',
                webhookTypes: ['channel-hangup']
              }
            }
            if (this.integration) integrationParams.id = this.integration.id
            if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)
            if (this.token) integrationParams.metadata.token = this.token
            else delete integrationParams.metadata.token
            if (this.userId) integrationParams.metadata.userId = this.userId
            else delete integrationParams.metadata.userId
            loopback
              .patch('/integrations', integrationParams)
              .then(integration => {
                this.integration = integration
                this.configReady = true
                $(this.$refs.updateIntegration).modal('hide')
                $(this.$refs.successIntegration).modal('show')
                return resolve()
              })
              .catch(err => {
                this.error = err
              })
          }).catch(err => {
            this.error = 'Falha na validação do token. Por favor, verifique o seu token e tente novamente.'
            reject(err)
          })
        } else {
          this.configReady = false
          this.error = 'O token não pode estar vazio.'
        }
      })
    },
    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.error = null
      this.loadUsers().then(_ => {
        this.configReady = true
      })
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.configReady = false
          this.usersOptions = []
          this.userId = null
          this.token = null
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    loadUsers () {
      if (this.token) {
        return loopback
          .get(`/integrations/clickup/user?token=${this.token}`)
          .then(user => {
            if (!this.userId && user) {
              this.userId = user.id
            }
            this.usersOptions = []
            this.usersOptions.push({
              value: user.id,
              text: `${user.username} (${user.email})`
            })
            this.configReady = true
            this.error = null
            this.isLoadingUsers = false
          })
          .catch(() => {
            this.configReady = false
            this.error = 'Token inválido'
          })
      } else {
        this.configReady = false
      }
    },
    errorHandle (err) {
      console.error(err)
      this.error = 'Houve um problema com a autenticação da integração. Talvez seja necessário reinstalar essa integração.'
    },
    openTutorial () {
      this.$refs.tutorialClickup.open()
    }
  },
  computed: {
    // TEL-2243: estas telas guardam `error` ora como string escrita por elas, ora
    // como o erro cru do transporte — que em `v-html` virava `[object Object]`.
    // O ErrorAlert aceita os dois formatos; aqui so montamos o envelope.
    errorAlert () {
      if (!this.error) return null
      return typeof this.error === 'string' ? { lines: [this.error] } : this.error
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'clickup'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    token: function () {
      this.loadUsers()
    }
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Integration/Clickup.vue